import {HttpBackend, HttpClient} from '@angular/common/http';
import {AuthClientConfig} from '@auth0/auth0-angular';
import {inject} from '@angular/core';
import {OctDocumentService} from '@services/document';
import {EnvironmentService} from '@services/environment';
import {firstValueFrom} from 'rxjs';

export const configAuth0Initializer = (handler: HttpBackend, config: AuthClientConfig) => {
  const document = inject(OctDocumentService);
  const environmentService = inject(EnvironmentService);
  return () =>
    firstValueFrom(
      new HttpClient(handler).get(`${environmentService.apiUrl}/companies/${document.activeCompanyPrefix()}/settings/login`)
    ).then((loadedConfig: {clientId: string; domain: string}) => {
      config.set({
        ...loadedConfig,
        useRefreshTokens: true,
        cacheLocation: 'localstorage',
        ...{
          authorizationParams: {
            redirect_uri: window.location.origin
          }
        }
      });
    });
};
